import React, { Component } from 'react';

class swaggerGenAiCopywriter extends Component {
  getSwaggerUrl = () => {
    const basePath = '/swagger-ui.html?urls.primaryName=copywriter';
    
    // 안전한 접근을 위해 window 객체가 존재하는지 확인 (SSR 환경 대비)
    if (typeof window !== 'undefined') {
      const hostname = window.location.hostname;
      
      // 도메인이 127.0.0.1일 경우 포트 8092를 명시한 전체 URL 반환
      if (hostname === '127.0.0.1') {
        return `http://127.0.0.1:8092${basePath}`;
      }
    }
    
    // 그 외의 도메인인 경우 기존 상대 경로 반환
    return basePath;
  };

  render() {
    return (
      <div id='page-wrapper' className="container swaggerViewer">
        <style>
          {
            `
              #root:has(.swaggerViewer) {
                height: 100vh !important; max-height: 100vh !important;
                overflow: hidden !important;
              }
              .swaggerViewer#page-wrapper {
                padding-top: 72px !important;
                max-width: 100% !important;
              }
              .swaggerViewer iframe {
                height: calc(100vh - 72px) !important;
              }
              @media (max-width: 800px) {
                .swaggerViewer#page-wrapper {
                  padding-top: 60px !important;
                }
                .swaggerViewer iframe {
                  height: calc(100dvh - 60px) !important;
                }
                #root:has(.swaggerViewer) {
                  height: calc(100dvh - 60px - 72px) !important; max-height: 100dvh !important;
                  overflow: hidden !important;
                }
              }
            `
          }
        </style>

        <div style={{ width: '100%', height: 'auto' }}>
            <iframe
            src={this.getSwaggerUrl()}
            title="GenAI Swagger UI"
            width="100%"
            height="100%"
            style={{ border: 'none' }}
            allowFullScreen
            />
        </div>
      </div>  
    );
  }
}

export default swaggerGenAiCopywriter;